module.exports = __webpack_public_path__ + "static/media/male_back_grey.13b6754d.png";